import { Container, Typography } from "@mui/material";
import DetailForm from "@/templates/PromptTemplate/DetailForm";
import usePromptTemplateDetail from "./usePromptTemplateDetail";

export default function PromptTemplateDetailPage() {
  const { data, form, loading, handleSubmit, handleDelete, handleCancel } =
    usePromptTemplateDetail();

  return (
    <Container maxWidth="xl">
      <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
        Edit Prompt Template
      </Typography>

      <DetailForm
        data={data}
        form={form}
        loading={loading}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
        onCancel={handleCancel}
      />
    </Container>
  );
}
